<template>
  <div class="hidden"></div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {mapActions} from 'vuex'
  export default {
    name: 'PushNotifications',
    computed: {
      ...mapGetters('user', ['SWLoaded', 'userPushPublicKey', 'SW'])
    },
    async mounted() {
      await this.SWLoaded
      const subscription = await this.SW.pushManager.getSubscription()
      
      if (subscription && Notification.permission === 'granted') {
        this.subscribeToPushNotifications({subscription, method: 'PUT'})
      } else if (!subscription && Notification.permission === 'granted') {
        this.SW.pushManager
          .subscribe({
            userVisibleOnly: true,
            applicationServerKey: this.$helpers.urlBase64ToUint8Array(this.userPushPublicKey)
          })
          .then(async subscription => {
            await this.subscribeToPushNotifications({subscription, method: 'POST'})
            this.pushEnabledOnLoad = true
          })
      }
    },
    methods: {
      ...mapActions('user', ['subscribeToPushNotifications'])
    }
  }
</script>
